import AssetCard from './assetCard';

export default AssetCard;



// WEBPACK FOOTER //
// ./src/components/elements/assetCard/index.js